import { userState } from '@/src/redux/userSlice/userSlice';
import Modal from '../Modal';
import CompanyRegistrationForm from './CompanyRegistrationForm';
import { useSearchParams } from 'next/navigation';
import { useSelector } from 'react-redux';
import { RootState } from '@/src/redux/store';
import { useGetUserQuery } from '@api/api';
import AuthenticationModal from '@components/AuthenticationModal';

export default function CompanyRegistrationModal() {
  const searchParams = useSearchParams();
  const showRegistrationForm = searchParams.get('modal') === 'register-company';
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });
  const { data: fetchedUser } = useGetUserQuery(user.userId, {
    skip: !user.loggedIn,
  });
  const userData = fetchedUser?.data;

  if (!userData || !showRegistrationForm) {
    return null;
  }

  if (showRegistrationForm && userData && !userData.identity_verified_at) {
    return <AuthenticationModal />;
  }

  return (
    <>
      {showRegistrationForm && (
        <Modal backgroundClose={false} width={600}>
          <CompanyRegistrationForm />
        </Modal>
      )}
    </>
  );
}
